export var LegalEntityQueryKey;
(function (LegalEntityQueryKey) {
    LegalEntityQueryKey["LegalEntities"] = "LegalEntities";
    LegalEntityQueryKey["LegalEntityNames"] = "LegalEntityNames";
})(LegalEntityQueryKey || (LegalEntityQueryKey = {}));
